import { render, staticRenderFns } from "./bill_of_materials.vue?vue&type=template&id=5f9b6736&scoped=true&"
import script from "./bill_of_materials.vue?vue&type=script&lang=js&"
export * from "./bill_of_materials.vue?vue&type=script&lang=js&"
import style0 from "./bill_of_materials.vue?vue&type=style&index=0&id=5f9b6736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9b6736",
  null
  
)

export default component.exports